module.exports = __webpack_public_path__ + "img/mDC.3c866af7.png";